export const EducationData = {
    "university": {
        "image": "res/img/android_logo.png",
        "date": "2020",
        "name": "University of Nottingham",
        "course": "BSc Computer Science",
        "grade": "2:1 with Honours",
        "description":
            `Studying at the University of Nottingham, I worked with a variety of technologies from low-level 
             C and ARM assembly to software development methods, computer security and OpenGL.

             First and second years were focused on lower-level topics, such as computer fundamentals (CPU design,
             memory/caching, concurrency), designing database systems and retrieval of queries, to foundations of artificial 
             intelligence and compiler/language design.

             I was also a part of a group project where we achieved 66% overall, recreating the 1984 programming 
             game CoreWar as an Android game; this focused on collaborating between the group and delegating tasks.

             For my final year, I undertook a dissertation focusing on delay-tolerant networks and how they are best
             implemented on a network level, their limitations in a variety of contexts (remote areas, satellites) and 
             solutions both existing and proposed. For the project, I designed and implemented a Texas Hold'em game
             to allow those with unstable connections time to react, reconnect and play as normal.
             `
    },

    "college": {
        "image": "res/img/android_logo.png",
        "date": "2017",
        "name": "Boston College UK",
        "course": "Extended National Diploma in Software Development",
        "grade": "D*D*D*",
        "description":
            `At Boston College I studied general computing in my first year, programming with
            different paradigms (procedural, event-driven, object-orientated) and principles of other areas, 
            such as networking, PC maintenance and server setup.

            In my second year, I specialized in software development where I was involved in small group
            projects using different methodologies such as Waterfall or Agile. Alongside this, I studied game
            development using Unreal Engine 4.

            Throughout the years, I was assigned to help students from my own and lower years with
            picking up and learning languages (C++/C#/VB).
            `
    },

    "school": {

    }
}
